import { render, staticRenderFns } from "./TableHeaderSort.vue?vue&type=template&id=3681a4e6"
import script from "./TableHeaderSort.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderSort.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports